import ControlledField from '../../ControlledField';
import FormNote from '../../FormNote';
import FormRadioGroup from '../../FormRadioGroup';
import FormSelect from '../../FormSelect';
import { type FormCustomQuestionProps } from '../types';

const ChoiceQuestion = ({
  name,
  label,
  helpText,
  isRequired,
  options,
}: FormCustomQuestionProps) => {
  const controlOptions = options.map((option) => ({
    label: option.label,
    value: option.id,
  }));

  return (
    <ControlledField name={name}>
      <div>
        <ControlledField.Label isRequired={isRequired}>{label}</ControlledField.Label>
        {helpText && <FormNote>{helpText}</FormNote>}
      </div>
      {options.length > 5 ? (
        <ControlledField.Control
          as={FormSelect}
          options={controlOptions}
          isSearchable={false}
          isClearable={!isRequired}
        />
      ) : (
        <ControlledField.Control
          as={FormRadioGroup}
          options={controlOptions}
          isRequired={isRequired}
        />
      )}
      <ControlledField.ErrorMessage />
    </ControlledField>
  );
};

export default ChoiceQuestion;
